import { MascotEmpty } from './Watermark';

export function Loader({ label }: { label?: string }) {
  return (
    <div className="center-state">
      <div className="spinner" />
      {label && <div className="tiny">{label}</div>}
    </div>
  );
}

export function ErrorView({ message }: { message?: string }) {
  return (
    <div className="center-state">
      <MascotEmpty />
      <div>Что-то пошло не так</div>
      {message && <div className="tiny muted">{message}</div>}
      <button
        className="btn"
        style={{ marginTop: 14 }}
        onClick={() => window.location.reload()}
      >
        Обновить
      </button>
    </div>
  );
}

export function EmptyView({ message }: { message: string }) {
  return (
    <div className="center-state">
      <MascotEmpty />
      <div className="muted">{message}</div>
    </div>
  );
}
